// Default fuel prices per currency (updated periodically — user can override)
export const DEFAULT_FUEL_PRICES = {
  EUR: { diesel: 1.55, gasoline: 1.65 },
  USD: { diesel: 1.10, gasoline: 1.20 },
  AOA: { diesel: 400,  gasoline: 300  },
  NAD: { diesel: 23.50, gasoline: 25.00 },
  ZAR: { diesel: 23.50, gasoline: 25.00 },
};

// Fallback rates relative to EUR (used when API is unavailable). Atualizadas
// periodicamente; o fetchExchangeRates() \u00E0 live API sobrep\u00F5e estas em runtime.
export const CURRENCIES = [
  // Base de opera\u00E7\u00E3o
  { code: 'EUR', symbol: '\u20AC',  label: 'Euro',               flag: '\uD83C\uDDEA\uD83C\uDDFA', rate: 1.0    },
  { code: 'USD', symbol: '$',       label: 'D\u00F3lar',         flag: '\uD83C\uDDFA\uD83C\uDDF8', rate: 1.08   },
  // Europa fora UE
  { code: 'GBP', symbol: '\u00A3',  label: 'Libra',              flag: '\uD83C\uDDEC\uD83C\uDDE7', rate: 0.84   },
  { code: 'CHF', symbol: 'Fr.',     label: 'Franco Su\u00ED\u00E7o', flag: '\uD83C\uDDE8\uD83C\uDDED', rate: 0.95 },
  { code: 'DKK', symbol: 'kr',      label: 'Coroa Dinamarquesa', flag: '\uD83C\uDDE9\uD83C\uDDF0', rate: 7.45   },
  { code: 'SEK', symbol: 'kr',      label: 'Coroa Sueca',        flag: '\uD83C\uDDF8\uD83C\uDDEA', rate: 11.2   },
  { code: 'NOK', symbol: 'kr',      label: 'Coroa Norueguesa',   flag: '\uD83C\uDDF3\uD83C\uDDF4', rate: 11.7   },
  { code: 'ISK', symbol: 'kr',      label: 'Coroa Island.',      flag: '\uD83C\uDDEE\uD83C\uDDF8', rate: 150    },
  { code: 'PLN', symbol: 'z\u0142', label: 'Z\u0142oty',         flag: '\uD83C\uDDF5\uD83C\uDDF1', rate: 4.3    },
  { code: 'CZK', symbol: 'K\u010D', label: 'Coroa Checa',        flag: '\uD83C\uDDE8\uD83C\uDDFF', rate: 25.2   },
  { code: 'HUF', symbol: 'Ft',      label: 'Forint',             flag: '\uD83C\uDDED\uD83C\uDDFA', rate: 405    },
  { code: 'RON', symbol: 'lei',     label: 'Leu',                flag: '\uD83C\uDDF7\uD83C\uDDF4', rate: 4.97   },
  { code: 'BGN', symbol: '\u043B\u0432', label: 'Lev',           flag: '\uD83C\uDDE7\uD83C\uDDEC', rate: 1.96   },
  { code: 'RSD', symbol: '\u0434\u0438\u043D', label: 'Dinar S\u00E9rvio', flag: '\uD83C\uDDF7\uD83C\uDDF8', rate: 117 },
  // \u00C1frica Lus\u00F3fona
  { code: 'AOA', symbol: 'Kz',      label: 'Kwanza',             flag: '\uD83C\uDDE6\uD83C\uDDF4', rate: 972.0  },
  { code: 'MZN', symbol: 'MT',      label: 'Metical',            flag: '\uD83C\uDDF2\uD83C\uDDFF', rate: 70     },
  { code: 'CVE', symbol: '$',       label: 'Escudo Cabo-Verd.',  flag: '\uD83C\uDDE8\uD83C\uDDFB', rate: 110    },
  { code: 'STN', symbol: 'Db',      label: 'Dobra',              flag: '\uD83C\uDDF8\uD83C\uDDF9', rate: 24.5   },
  { code: 'XOF', symbol: 'CFA',     label: 'Franco CFA Oeste',   flag: '\uD83C\uDDFC\uD83C\uDDEB', rate: 656    },
  { code: 'XAF', symbol: 'CFA',     label: 'Franco CFA Central', flag: '\uD83C\uDDE8\uD83C\uDDEB', rate: 656    },
  // \u00C1frica Austral
  { code: 'NAD', symbol: 'N$',      label: 'D\u00F3lar Namibiano', flag: '\uD83C\uDDF3\uD83C\uDDE6', rate: 20.5 },
  { code: 'ZAR', symbol: 'R',       label: 'Rand',               flag: '\uD83C\uDDFF\uD83C\uDDE6', rate: 20.5   },
  { code: 'BWP', symbol: 'P',       label: 'Pula',               flag: '\uD83C\uDDE7\uD83C\uDDFC', rate: 14.5   },
  { code: 'ZMW', symbol: 'ZK',      label: 'Kwacha Zambiano',    flag: '\uD83C\uDDFF\uD83C\uDDF2', rate: 28     },
  { code: 'ZWL', symbol: 'Z$',      label: 'D\u00F3lar Zimbabuano', flag: '\uD83C\uDDFF\uD83C\uDDFC', rate: 14000 },
  { code: 'MWK', symbol: 'MK',      label: 'Kwacha Malawi',      flag: '\uD83C\uDDF2\uD83C\uDDFC', rate: 1850   },
  { code: 'MUR', symbol: '\u20A8',  label: 'Rupia Mauric.',      flag: '\uD83C\uDDF2\uD83C\uDDFA', rate: 49     },
  { code: 'MGA', symbol: 'Ar',      label: 'Ariary',             flag: '\uD83C\uDDF2\uD83C\uDDEC', rate: 4800   },
  // \u00C1frica Central/Oriental
  { code: 'CDF', symbol: 'FC',      label: 'Franco Congol.',     flag: '\uD83C\uDDE8\uD83C\uDDE9', rate: 3000   },
  { code: 'RWF', symbol: 'FRw',     label: 'Franco Ruandes',     flag: '\uD83C\uDDF7\uD83C\uDDFC', rate: 1400   },
  { code: 'NGN', symbol: '\u20A6',  label: 'Naira',              flag: '\uD83C\uDDF3\uD83C\uDDEC', rate: 1750   },
  { code: 'GHS', symbol: '\u20B5',  label: 'Cedi',               flag: '\uD83C\uDDEC\uD83C\uDDED', rate: 16     },
  { code: 'KES', symbol: 'KSh',     label: 'Xelim Queniano',     flag: '\uD83C\uDDF0\uD83C\uDDEA', rate: 140    },
  { code: 'TZS', symbol: 'TSh',     label: 'Xelim Tanzaniano',   flag: '\uD83C\uDDF9\uD83C\uDDFF', rate: 2900   },
  { code: 'UGX', symbol: 'USh',     label: 'Xelim Ugandes',      flag: '\uD83C\uDDFA\uD83C\uDDEC', rate: 4100   },
  { code: 'ETB', symbol: 'Br',      label: 'Birr',               flag: '\uD83C\uDDEA\uD83C\uDDF9', rate: 130    },
  // Norte de \u00C1frica
  { code: 'MAD', symbol: 'DH',      label: 'Dirham',             flag: '\uD83C\uDDF2\uD83C\uDDE6', rate: 10.9   },
  { code: 'DZD', symbol: 'DA',      label: 'Dinar Argelino',     flag: '\uD83C\uDDE9\uD83C\uDDFF', rate: 145    },
  { code: 'TND', symbol: 'DT',      label: 'Dinar Tunisino',     flag: '\uD83C\uDDF9\uD83C\uDDF3', rate: 3.4    },
  { code: 'EGP', symbol: 'E\u00A3', label: 'Libra Eg\u00EDpcia', flag: '\uD83C\uDDEA\uD83C\uDDEC', rate: 53     },
  { code: 'LYD', symbol: 'LD',      label: 'Dinar L\u00EDbio',   flag: '\uD83C\uDDF1\uD83C\uDDFE', rate: 5.2    },
];

export function getCurrency(code, liveRates) {
  const base = CURRENCIES.find(c => c.code === code) ?? CURRENCIES[0];
  if (liveRates && base.code !== 'EUR' && liveRates[base.code]) {
    return { ...base, rate: liveRates[base.code] };
  }
  return base;
}

export function getCurrencySymbol(code) {
  return (CURRENCIES.find(c => c.code === code) ?? CURRENCIES[0]).symbol;
}

// ── Fuel price persistence ────────────────────────────────────────────────────
const FUEL_PRICE_KEY = 'ecoogps_fuel_prices';

export function getSavedFuelPrice(currency, fuelType) {
  try {
    const saved = JSON.parse(localStorage.getItem(FUEL_PRICE_KEY) || '{}');
    return saved[`${currency}_${fuelType}`] ?? DEFAULT_FUEL_PRICES[currency]?.[fuelType] ?? DEFAULT_FUEL_PRICES.EUR[fuelType];
  } catch {
    return DEFAULT_FUEL_PRICES[currency]?.[fuelType] ?? DEFAULT_FUEL_PRICES.EUR[fuelType];
  }
}

export function saveFuelPrice(currency, fuelType, price) {
  try {
    const saved = JSON.parse(localStorage.getItem(FUEL_PRICE_KEY) || '{}');
    saved[`${currency}_${fuelType}`] = price;
    localStorage.setItem(FUEL_PRICE_KEY, JSON.stringify(saved));
  } catch {}
}

// ── Live exchange rates ───────────────────────────────────────────────────────
const CACHE_KEY = 'ecoogps_fx_rates';
const CACHE_TTL = 60 * 60 * 1000; // 1 hour

/**
 * Fetches EUR-based exchange rates from open.er-api.com (free, no key needed).
 * Returns { USD, AOA, ... } or null if unavailable (use fallback rates).
 * Results are cached in localStorage for 1 hour.
 */
export async function fetchExchangeRates() {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      const { rates, timestamp } = JSON.parse(cached);
      if (Date.now() - timestamp < CACHE_TTL) return { rates, live: true, cached: true };
    }
    const res = await fetch('https://open.er-api.com/v6/latest/EUR', { cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    if (data.result !== 'success') throw new Error('API error');
    const rates = data.rates; // full map: { USD: 1.08, AOA: 972, ... }
    localStorage.setItem(CACHE_KEY, JSON.stringify({ rates, timestamp: Date.now() }));
    return { rates, live: true, cached: false };
  } catch (e) {
    console.warn('[currencies] exchange rate fetch failed:', e.message);
    return null; // caller uses hardcoded fallback
  }
}
